export enum AreaCodeDropdown {
  GET_AREA_CODE_DROPDOWN_LIST = "GET_AREA_CODE_DROPDOWN_LIST",
  SET_AREA_CODE_DROPDOWN_LOADING = "SET_AREA_CODE_DROPDOWN_LOADING",
  SET_AREA_CODE_DROPDOWN_LIST = "SET_AREA_CODE_DROPDOWN_LIST",
}

export interface AreaCodeDropdownActionType {
  type: AreaCodeDropdown;
  payload: any;
}